import axios from 'axios'

const baseUrl = String(process.env.REACT_APP_API_URL).trim()
const prefijo = String(process.env.REACT_APP_PREFIJO_STORAGE)

axios.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(prefijo + 'accessToken')
    const tipo = localStorage.getItem(prefijo + 'tipoConsulta')
    if (tipo === 'XML') {
      config.headers = {
        Accept: 'text/xml',
        'Content-Type': 'application/json;charset=UTF-8',
      }
    } else if (accessToken) {
      if (tipo === 'PDF') {
        config.headers = {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        }
        config.responseType = 'arraybuffer'
      } else {
        config.headers = {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        }
      }
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    const originalRequest = error.config
    let refreshToken = localStorage.getItem(prefijo + 'refreshToken')
    if (refreshToken && error.response.status === 440 && !originalRequest._retry) {
      originalRequest._retry = true
      return axios.post(`${baseUrl}/auth/refresh`, { refreshToken: refreshToken }).then((res) => {
        if (res.status === 200) {
          localStorage.setItem(prefijo + 'accessToken', res.data.accessToken)
          localStorage.setItem(prefijo + 'refreshToken', res.data.refreshToken)
          return axios(originalRequest)
        }
      })
    }
    return Promise.reject(error)
  },
)

const api = {
  //Rutas de autenticación
  refreshToken: (body) => {
    return axios.post(`${baseUrl}/auth/refresh_token`, body)
  },
  noticia: (body) => {
    return axios.get(`${baseUrl}/home/noticias`, body)
  },
  portalNoticias: (body) => {
    return axios.post(`${baseUrl}/portal/noticias`, body)
  },
  portalNoticiasVideos: (body) => {
    return axios.post(`${baseUrl}/portal/noticias/videos`, body)
  },
  portalNoticiasTema: (body) => {
    return axios.post(`${baseUrl}/portal/noticias/tema`, body)
  },
  portalNoticiasImg: (body) => {
    return axios.post(`${baseUrl}/portal/noticias/imagen`, body)
  },
  transparenciaNomina: (body) => {
    return axios.post(`${baseUrl}/transparencia/nomina`, body)
  },
  getIp: (body) => {
    return axios.get(`${baseUrl}/getIp`, body)
  },
  tramitesHome: (body) => {
    return axios.get(`${baseUrl}/home/menu_tramites`, body)
  },
  tramites: (body) => {
    return axios.post(`${baseUrl}/tramites`, body)
  },
  organismos: (body) => {
    return axios.post(`${baseUrl}/organismos`, body)
  },
  noticias: (body) => {
    return axios.post(`${baseUrl}/noticias`, body)
  },
  portada_imagen: (body) => {
    return axios.post(`${baseUrl}/portada/imagen`, body)
  },
  noticias_imagen: (body) => {
    return axios.post(`${baseUrl}/noticias/imagen`, body)
  },
  paginas: (body) => {
    return axios.post(`${baseUrl}/paginas`, body)
  },
  contando: (body) => {
    return axios.post(`${baseUrl}/c_buscador`, body)
  },
  tramitesDetalle: (body) => {
    return axios.post(`${baseUrl}/tramite`, body)
  },
  tramite_multimedia: (body) => {
    return axios.post(`${baseUrl}/tramite_multimedia`, body)
  },
  gestion: (body) => {
    return axios.get(`${baseUrl}/home/menu_gestion`, body)
  },
  interes: (body) => {
    return axios.get(`${baseUrl}/home/menu_interes`, body)
  },
  acceso: (body) => {
    return axios.get(`${baseUrl}/home/menu_acceso`, body)
  },
  archivoInteres: (body) => {
    return axios.post(`${baseUrl}/interes/archivos`, body)
  },
  banner: (body) => {
    return axios.get(`${baseUrl}/home/menu_banner`, body)
  },
  archivo: (body) => {
    return axios.post(`${baseUrl}/home/menu_banner/archivo`, body)
  },
  tramite_archivo: (body) => {
    return axios.post(`${baseUrl}/tramite_archivo`, body)
  },
  anios_inform_electoral: (body) => {
    return axios.get(`${baseUrl}/informacion_electoral/anios`, body)
  },
  inform_electoral_anio: (body) => {
    return axios.post(`${baseUrl}/informacion_electoral/detalle_anio`, body)
  },
  inf_electoral_archivo: (body) => {
    return axios.post(`${baseUrl}/informacion_electoral/inf_electoral_archivo`, body)
  },
  organismos_tramites: (body) => {
    return axios.get(`${baseUrl}/organismo-tramites`, body)
  },
  tramites_organismo: (body) => {
    return axios.post(`${baseUrl}/tramites_por_organismo`, body)
  },
  menu: (body) => {
    return axios.get(`${baseUrl}/home/menu`, body)
  },
  miga: (body) => {
    return axios.post(`${baseUrl}/sitios/miga`, body)
  },
  sistemas: (body) => {
    return axios.post(`${baseUrl}/sistemas`, body)
  },
  correo: ({ usuario }) => {
    return axios.get(`${baseUrl}/correos/${usuario}`)
  },
  aviso: (body) => {
    return axios.post(`${baseUrl}/aviso`, body)
  },
  //modulo noticias
  sitiosNoticias: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias`, body)
  },
  //cantidad de noticia por sitio
  sitiosNoticiasCantidad: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/cantidad`, body)
  },
  //cantidad de noticia por sitio
  sitiosNoticiasRango: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/rango`, body)
  },
  //modulo noticias detalle
  sitiosNoticiasDet: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/detalle`, body)
  },
  //modulo noticias imagen
  sitiosNoticiasImg: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/imagen`, body)
  },
  //modulo noticias audio
  sitiosNoticiasAudio: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria/audio`, body)
  },
  //modulo noticias audio detalle
  sitiosNoticiasAudioDetalle: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria/audio/detalle`, body)
  },
  //modulo noticias video
  sitiosNoticiasvideo: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria/video`, body)
  },
  //modulo noticias video detalle
  sitiosNoticiasVideoDetalle: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria/video/detalle`, body)
  },
  //modulo noticias galeria
  sitiosNoticiasGaleria: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria`, body)
  },
  //modulo noticias galeria
  sitiosNoticiasGaleriaImagen: (body) => {
    return axios.post(`${baseUrl}/sitios/noticias/galeria/detalle`, body)
  },
  sitios: (body) => {
    return axios.get(`${baseUrl}/sitios`, body)
  },
  sitiosDatos: (body) => {
    return axios.post(`${baseUrl}/sitios/datos`, body)
  },
  obtenerPaginaSitio: (body) => {
    return axios.post(`${baseUrl}/sitios/pagina`, body)
  },
  getImagenContenido: (body) => {
    return axios.post(`${baseUrl}/contenido/imagen`, body)
  },
  getCarpetasArchivos: (body) => {
    return axios.post(`${baseUrl}/contenido/carpetas`, body)
  },
  getArchivoPorID: (body) => {
    return axios.post(`${baseUrl}/contenido/archivo`, body)
  },
  obtenerCompContacto: (body) => {
    return axios.post(`${baseUrl}/sitios/complemento/contacto`, body)
  },
  obtenerCompEnlaces: (body) => {
    return axios.post(`${baseUrl}/sitios/complemento/enlaces`, body)
  },
  obtenerCompNormativas: (body) => {
    return axios.post(`${baseUrl}/sitios/complemento/normativas`, body)
  },
  obtenerCompDescargas: (body) => {
    return axios.post(`${baseUrl}/sitios/complemento/descargas`, body)
  },
  obtenerCompTramites: (body) => {
    return axios.post(`${baseUrl}/sitios/complemento/tramites`, body)
  },
  sitiosEncabezado: (body) => {
    return axios.post(`${baseUrl}/sitios/encabezado`, body)
  },
  sitiosEncabezadoCompleto: (body) => {
    return axios.post(`${baseUrl}/sitios/encabezado_f`, body)
  },
  sitiosSubmenu: (body) => {
    return axios.post(`${baseUrl}/sitios/submenu`, body)
  },
  sitiosMenu: (body) => {
    return axios.post(`${baseUrl}/sitios/menu`, body)
  },
  sitiosDestacados: (body) => {
    return axios.post(`${baseUrl}/sitios/destacados`, body)
  },
  sitiosAccesos: (body) => {
    return axios.post(`${baseUrl}/sitios/accesos`, body)
  },
  sitiosHomeNoticias: (body) => {
    return axios.post(`${baseUrl}/sitios/home/noticias`, body)
  },
  sitiosHomeTramites: (body) => {
    return axios.post(`${baseUrl}/sitios/home/tramites`, body)
  },
  sitiosAutoridades: (body) => {
    return axios.post(`${baseUrl}/sitios/home/autoridades`, body)
  },
  obtenerArchivosPaginaSitio: (body) => {
    return axios.post(`${baseUrl}/sitio/pagina/archivos`, body)
  },
  obtenerCronograma: (body) => {
    return axios.get(`${baseUrl}/portal/noticias/cronograma`, body)
  },

  //Formularios
  obtenerFormulario: (body) => {
    return axios.post(`${baseUrl}/formulario/busca`, body)
  },

  //Consultas
  obtenerConsulta: (body) => {
    return axios.get('https://testing54.entrerios.gov.ar/boletin/factura/inicio/get_buscador', body)
  },

  //Obtener consulta por nombre
  obtenerConsultaPorNombre: ({ nombre }) => axios.get(`${baseUrl}/consulta/${nombre}`),

  insertarRegistroForm: (body, headers = {}) => {
    return axios.post(`${baseUrl}/formulario/insertaregistro`, body, {
      'Content-Type': 'multipart/form-data',
    })
  },
  enviarRegistroForm: (body, headers = {}) => {
    return axios.post(`${baseUrl}/formulario/enviaregistro`, body, headers)
  },

  //CONSULTAS

  licitacionesUEP: (body) => {
    return axios.get(`${baseUrl}/consulta/uep/licitaciones`, body)
  },
  licitacionesUEPArchivos: ({ licitacion }) => {
    return axios.get(`${baseUrl}/consulta/uep/licitaciones/archivos/${licitacion}`)
  },
  concursosPrecios: ({ formID }) => {
    return axios.get(`${baseUrl}/consulta/uep/concursosprecios/${formID}`)
  },
  contrataciones: ({ formID }) => {
    return axios.get(`${baseUrl}/consulta/uep/contrataciones/${formID}`)
  },
  getConcursosPreciosArchivo: ({ atributo_id, idReg }) => {
    return `${baseUrl}/consulta/uep/archivo/${atributo_id}/${idReg}` ///${filename}.${extension}`
    //return axios.get(`${baseUrl}/consulta/uep/concursosprecios/archivo/${atributo_id}/${idReg}/file.pdf`)
  },

  // Comunicacion -> Listado registro de medios
  getListadoRegistroMedios: () => {
    return axios.get(`${baseUrl}/consulta/comunicacion/listado-proveedores`)
  },
  busquedaListadoRegistroMedios: (params) => {
    return axios.get(`${baseUrl}/consulta/comunicacion/listado-proveedores${params}`)
  },

  //Liquidaciones -> Normativas
  getNormativasLiquidaciones: () => {
    return axios.get(`${baseUrl}/consulta/liquidaciones/normativas`)
  },
  busquedaNormativasLiquidaciones: (params) => {
    return axios.get(`${baseUrl}/consulta/liquidaciones/normativas${params}`)
  },

  //Contaduria -> Coparticipacion
  contaduriaCoparticipacion: () => {
    return axios.get(`${baseUrl}/consulta/contaduria/coparticipacion`)
  },
  busquedaContaduriaCoparticipacion: (params) => {
    return axios.get(`${baseUrl}/consulta/contaduria/coparticipacion${params}`)
  },
  busquedaContaduriaCoparticipacionDiaria: (params) => {
    return axios.get(`${baseUrl}/consulta/contaduria/coparticipacion${params}`)
  },

  //REESER -> Consulta de efectores inscriptos
  reeserGetSubrubros: () => axios.get(`${baseUrl}/consulta/reeser/subrubros`),
  reeserGetActividades: ({ subrubro }) =>
    axios.get(`${baseUrl}/consulta/reeser/${subrubro}/actividades`),

  getAllEfectores: () => axios.get(`${baseUrl}/consulta/reeser/efectores`),
  getBySubrubro: (subrubro) =>
    axios.get(`${baseUrl}/consulta/reeser/subrubro/${subrubro}/efectores`),
  getByActividad: (actividad) =>
    axios.get(`${baseUrl}/consulta/reeser/actividad/${actividad}/efectores`),
  reeserVerificarCodigo: ({ codigo }) =>
    axios.get(`${baseUrl}/consulta/reeser/verificar/${codigo}`),

  //REESER -> Consulta de verificar constancia

  getConsulta: (body) => {
    return axios.post(`${baseUrl}/paginas/consultas`, body)
  },

  formipcymer: (body) => {
    return axios.post(`${baseUrl}/ipcymer/cooperativismo`, body)
  },
  form_relev_conectividad: (body) => {
    return axios.post(`${baseUrl}/formularios/form_relev_conectividad`, body)
  },
  provincias: (body) => {
    return axios.get(`${baseUrl}/provincias`, body)
  },
  departamentos: (body) => {
    return axios.get(`${baseUrl}/departamentos`, body)
  },
  form_registro_cooperativas: (body) => {
    return axios.post(`${baseUrl}/formularios/form_registro_cooperativas`, body)
  },
  form_capacitaciones_portal: (body) => {
    return axios.post(`${baseUrl}/formularios/form_capacitaciones_portal`, body)
  },
  form_adicion_apellido: (body) => {
    return axios.post(`${baseUrl}/formularios/form_adicion_apellido`, body)
  },
  form_preinscrip_familias_abrigo: (body) => {
    return axios.post(`${baseUrl}/formularios/form_preinscrip_familias_abrigo`, body)
  },
  form_adquirientes: (body) => {
    return axios.post(`${baseUrl}/formularios/form_adquirientes`, body)
  },
  form_requirentes: (body) => {
    return axios.post(`${baseUrl}/formularios/form_requirentes`, body)
  },
  form_preventores_adicciones: (body) => {
    return axios.post(`${baseUrl}/formularios/form_preventores_adicciones`, body)
  },
  form_puntos_wifi: (body) => {
    return axios.post(`${baseUrl}/formularios/form_puntos_wifi`, body)
  },
  form_reforma_politica: (body) => {
    return axios.post(`${baseUrl}/formularios/form_reforma_politica`, body)
  },
  form_nas: (body) => {
    return axios.post(`${baseUrl}/formularios/form_nas`, body)
  }, //como figura en la base de datos
  form_sh: (body) => {
    return axios.post(`${baseUrl}/formularios/form_sh`, body)
  },
  form_vps: (body) => {
    return axios.post(`${baseUrl}/formularios/form_vps`, body)
  },
  form_solicitud_quema: (body) => {
    return axios.post(`${baseUrl}/formularios/form_solicitud_quema`, body)
  },
  form_finalizacion_quema: (body) => {
    return axios.post(`${baseUrl}/formularios/form_finalizacion_quema`, body)
  },
  form_hakiaton: (body) => {
    return axios.post(`${baseUrl}/formularios/form_hakiaton`, body)
  },
  obtenerPersona: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerPersona`, body)
  },
  form_cisco: (body) => {
    return axios.post(`${baseUrl}/formularios/form_cisco`, body)
  },
  form_penitenciario_preinsc: (body) => {
    return axios.post(`${baseUrl}/formularios/form_penitenciario_preinsc`, body)
  },
  form_manifiesto_operador: (body) => {
    return axios.post(`${baseUrl}/formularios/form_manifiesto_operador`, body)
  },
  form_manifiesto_transportista: (body) => {
    return axios.post(`${baseUrl}/formularios/form_manifiesto_transportista`, body)
  },
  form_manifiesto_generador: (body) => {
    return axios.post(`${baseUrl}/formularios/form_manifiesto_generador`, body)
  },
  form_certificado_solteria: (body) => {
    return axios.post(`${baseUrl}/formularios/form_certificado_solteria`, body)
  },
  form_capac_virtual_gde: (body) => {
    return axios.post(`${baseUrl}/formularios/form_capac_virtual_gde`, body)
  },
  obtenerEmpleado: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerEmpleado`, body)
  },
  obtenerEmpleadoDatos: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerEmpleadoDatos`, body)
  },
  obtenerEmpleadoOrganismo: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerEmpleadoOrganismo`, body)
  },
  cantidadInscriptos: (body) => {
    return axios.post(`${baseUrl}/formularios/cantidadInscriptos`, body)
  },
  form_capac_presencial_gde: (body) => {
    return axios.post(`${baseUrl}/formularios/form_capac_presencial_gde`, body)
  },
  form_agentes: (body) => {
    return axios.post(`${baseUrl}/formularios/form_agentes`, body)
  },
  form_capac_youtube_gde: (body) => {
    return axios.post(`${baseUrl}/formularios/form_capac_youtube_gde`, body)
  },
  instituciones_escrut: (body) => {
    return axios.post(`${baseUrl}/formularios/instituciones_escrut`, body)
  },
  form_asist_goblocales: (body) => {
    return axios.post(`${baseUrl}/formularios/form_asist_goblocales`, body)
  },
  form_certificado_negativo_nacimiento: (body) => {
    return axios.post(`${baseUrl}/formularios/form_certificado_negativo_nacimiento`, body)
  },
  form_testimonios_bilingues: (body) => {
    return axios.post(`${baseUrl}/formularios/form_testimonios_bilingues`, body)
  },
  form_reconocimiento_paterno: (body) => {
    return axios.post(`${baseUrl}/formularios/form_reconocimiento_paterno`, body)
  },
  form_manifiesto_electronico: (body) => {
    return axios.post(`${baseUrl}/formularios/form_manifiesto_electronico`, body)
  },
  obtenerTransportista: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerTransportista`, body)
  },
  obtenerOperador: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerOperador`, body)
  },
  obtenerGenerador: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerGenerador`, body)
  },
  obtenerVehiculo: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerVehiculo`, body)
  },
  //finalizacion de manifiesto electrónico
  form_finalizacion_manifiesto: (body) => {
    return axios.post(`${baseUrl}/formularios/form_finalizacion_manifiesto`, body)
  },
  form_vehiculo_transportista: (body) => {
    return axios.post(`${baseUrl}/formularios/form_vehiculo_transportista`, body)
  },
  obtenerVehiculoTransportista: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerVehiculoTransportista`, body)
  },
  obtenerManifiestoTransportista: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerManifiestoTransportista`, body)
  },
  obtenerTransportistaGenerador: (body) => {
    return axios.post(`${baseUrl}/formularios/obtenerTransportistaGenerador`, body)
  },

  Form_preinscripcion_rini: (body) => {
    return axios.post(`${baseUrl}/formularios/form_preinscripcion_rini`, body)
  },
  form_transparencia: (body) => {
    return axios.post(`${baseUrl}/formularios/form_transparencia`, body)
  },
  //FIN CONSULTAS

  //Vista -> Coparticipación Tesoro
  getCoparticipacionTesoro: () => {
    return axios.get(`${baseUrl}/consulta/liquidaciones/normativas`)
  },
  busquedaCoparticipacionTesoro: (params) => {
    return axios.get(`${baseUrl}/consulta/liquidaciones/normativas${params}`)
  },
}

export default api
